module.exports = __webpack_public_path__ + "img/avatar-12.77db49b1.png";